export type Address = Readonly<{
    name1: string;
    name2: string;
    name3: string;
    name4: string;
    street: string;
    city: string;
    postCode: string;
    country: string;
    building: string;
    room: string;
    floor: string;
    department: string;
    contactName1: string;
    contactName2: string;
    contactPhone: string;
    contactType: string;
    email: string;
    phone: string;
    fax1: string;
    fax2: string;
    fax3: string;
    fax4: string;
    addrText: string;
    addrNumber: string;
    addrKey: number;
    state: string;
}>;

export const initialAddressState: Address = {
    addrKey: -1,
    addrNumber: '',
    addrText: '',
    building: '',
    city: '',
    contactName1: '',
    contactName2: '',
    contactPhone: '',
    contactType: '',
    country: '',
    department: '',
    fax1: '',
    fax2: '',
    fax3: '',
    fax4: '',
    floor: '',
    name1: '',
    name2: '',
    name3: '',
    name4: '',
    email: '',
    phone: '',
    postCode: '',
    room: '',
    state: '',
    street: '',
};
